const actionType = {
    GET_PROCTORING_CHAPTER:'GET_PROCTORING_CHAPTER',
    GET_PROCTORING_CHAPTER_SUCCESS:'GET_PROCTORING_CHAPTER_SUCCESS',
    GET_PROCTORING_CHAPTER_FAILURE:'GET_PROCTORING_CHAPTER_FAILURE'
}
export default actionType 